import GpsService from './gpsLocationService';

export default GpsService;
